import { BuildFeatureItemId } from "components/BuildFeatures/BuildFeatures.types";
import { TVideoCardFeatureV2 } from "pages/LayoutComponents/VideoCardGrid/VideoCardGrid.types";

// Camera Security Installation Addons assets
import cameraDualMountMp4 from "../assets/related-addons/camera-dual-mount.mp4";
import cameraDualMountPosterJpg from "../assets/related-addons/camera-dual-mount-poster.jpg";
import cameraDualMountPreviewPng from "../assets/related-addons/camera-dual-mount-preview.png";
import aiDomeCameraFlushmountMp4 from "../assets/related-addons/ai-dome-camera-flushmount.mp4";
import aiDomeCameraFlushmountPosterJpg from "../assets/related-addons/ai-dome-camera-flushmount-poster.jpg";
import aiDomeCameraFlushMountPreviewPng from "../assets/related-addons/ai-dome-camera-flush-mount-preview.png";
import domeCameraWeatherShieldMp4 from "../assets/related-addons/dome-camera-weather-shield.mp4";
import domeCameraWeatherShieldPosterJpg from "../assets/related-addons/dome-camera-weather-shield-poster.jpg";
import domeCameraWeatherShieldPreviewPng from "../assets/related-addons/dome-camera-weather-shield-preview.png";
import compactCameraJunctionBoxMp4 from "../assets/related-addons/compact-camera-junction-box.mp4";
import compactCameraJunctionBoxPosterJpg from "../assets/related-addons/compact-camera-junction-box-poster.jpg";
import cameraCompactJunctionBoxPreviewPng from "../assets/related-addons/camera-compact-junction-box-preview.png";
import g5TurretUltraCameraMountMp4 from "../assets/related-addons/g5-turret-ultra-camera-mount.mp4";
import g5TurretUltraCameraMountPosterJpg from "../assets/related-addons/g5-turret-ultra-camera-mount-poster.jpg";
import cameraArmMountPreviewPng from "../assets/related-addons/camera-arm-mount-preview.png";
import g5DomeUltraFlushMountMp4 from "../assets/related-addons/g5-dome-ultra-flush-mount.mp4";
import g5DomeUltraFlushMountPosterJpg from "../assets/related-addons/g5-dome-ultra-flush-mount-poster.jpg";
import g5DomeUltraFlushMountPreviewPng from "../assets/related-addons/g5-dome-ultra-flush-mount-preview.png";
import cameraJunctionBoxMp4 from "../assets/related-addons/camera-junction-box.mp4";
import cameraJunctionBoxPosterJpg from "../assets/related-addons/camera-junction-box-poster.jpg";
import cameraJunctionBoxPreviewPng from "../assets/related-addons/camera-junction-box-preview.png";
import ai360JunctionBoxMp4 from "../assets/related-addons/ai-360-junction-box.mp4";
import ai360JunctionBoxPosterJpg from "../assets/related-addons/ai-360-junction-box-poster.jpg";
import ai360JunctionBoxPreviewPng from "../assets/related-addons/ai-360-junction-box-preview.png";
import domeCameraArmMountMp4 from "../assets/related-addons/dome-camera-arm-mount.mp4";
import domeCameraArmMountPosterJpg from "../assets/related-addons/dome-camera-arm-mount-poster.jpg";
import domeCameraArmMountPreviewPng from "../assets/related-addons/dome-camera-arm-mount-preview.png";
import bulletCameraAngledBaseMp4 from "../assets/related-addons/bullet-camera-angled-base.mp4";
import bulletCameraAngledBasePosterJpg from "../assets/related-addons/bullet-camera-angled-base-poster.jpg";
import bulletCameraAngledBasePreviewPng from "../assets/related-addons/bullet-camera-angled-base-preview.png";
import bulletCameraJunctionBoxMp4 from "../../../../assets/related-addons/physical-security/bullet-camera-junction-box.mp4";
import bulletCameraJunctionBoxJpg from "../../../../assets/related-addons/physical-security/bullet-camera-junction-box.jpg";
import aiEnhancerMp4 from "../../../../assets/related-addons/physical-security/ai-enhancer.mp4";
import aiEnhancerJpg from "../../../../assets/related-addons/physical-security/ai-enhancer.jpg";
import aiEnhancerPreviewPng from "../assets/related-addons/ai-enhancer-preview.png";
import g5ProEnhancerMp4 from "../assets/related-addons/g5-pro-enhancer.mp4";
import g5ProEnhancerPosterJpg from "../assets/related-addons/g5-pro-enhancer-poster.jpg";
import g5ProEnhancerPreviewPng from "../assets/related-addons/g5-pro-enhancer-preview.png";
import flexProMountMp4 from "../assets/related-addons/flex-pro-mount.mp4";
import flexProMountPosterJpg from "../assets/related-addons/flex-pro-mount-poster.jpg";
import flexProMountPreviewPng from "../assets/related-addons/flex-pro-mount-preview.png";
import flexInCeilingMountMp4 from "../assets/related-addons/flex-in-ceiling-mount.mp4";
import flexInCeilingMountPosterJpg from "../assets/related-addons/flex-in-ceiling-mount-poster.jpg";
import flexInCeilingMountPreviewPng from "../assets/related-addons/flex-in-ceiling-mount-preview.png";
import flexPendantMountMp4 from "../assets/related-addons/flex-pendant-mount.mp4";
import flexPendantMountPosterJpg from "../assets/related-addons/flex-pendant-mount-poster.jpg";
import flexPendantMountPreviewPng from "../assets/related-addons/flex-pendant-mount-preview.png";
import g4InstantCoverMp4 from "../assets/related-addons/g4-instant-cover.mp4";
import g4InstantCoverPosterJpg from "../assets/related-addons/g4-instant-cover-poster.jpg";
import g4InstantCoverPreviewPng from "../assets/related-addons/g4-instant-cover-preview.png";
import aiThetaProAngleMountMp4 from "../assets/related-addons/ai-theta-pro-angle-mount.mp4";
import aiThetaProAngleMountPosterJpg from "../assets/related-addons/ai-theta-pro-angle-mount-poster.jpg";
import aiThetaProAngleMountPreviewPng from "../assets/related-addons/ai-theta-pro-angle-mount-preview.png";
import aiThetaAngleMountMp4 from "../assets/related-addons/ai-theta-angle-mount.mp4";
import aiThetaAngleMountPosterJpg from "../assets/related-addons/ai-theta-angle-mount-poster.jpg";
import aiThetaAngleMountPreviewPng from "../assets/related-addons/ai-theta-angle-mount-preview.png";
import aiThetaProFlushMountMp4 from "../assets/related-addons/ai-theta-pro-flush-mount.mp4";
import aiThetaProFlushMountPosterJpg from "../assets/related-addons/ai-theta-pro-flush-mount-poster.jpg";
import aiThetaProFlushMountPreviewPng from "../assets/related-addons/ai-theta-pro-flush-mount-preview.png";
import aiThetaCeilingMountMp4 from "../assets/related-addons/ai-theta-ceiling-mount.mp4";
import aiThetaCeilingMountPosterJpg from "../assets/related-addons/ai-theta-ceiling-mount-poster.jpg";
import aiThetaCeilingMountSystemPreviewPng from "../assets/related-addons/ai-theta-ceiling-mount-system-preview.png";
import aiThetaProLrMp4 from "../assets/related-addons/ai-theta-pro-lr.mp4";
import aiThetaProLrPosterJpg from "../assets/related-addons/ai-theta-pro-lr-poster.jpg";
import aiThetaProLongDistanceLensPreviewPng from "../assets/related-addons/ai-theta-pro-long-distance-lens-preview.png";
import aiThetaLrLensMp4 from "../assets/related-addons/ai-theta-lr-lens.mp4";
import aiThetaLrLensPosterJpg from "../assets/related-addons/ai-theta-lr-lens-poster.jpg";
import aiThetaLongDistanceLensPreviewPng from "../assets/related-addons/ai-theta-long-distance-lens-preview.png";
import aiThetaProWideAngleMp4 from "../assets/related-addons/ai-theta-pro-wide-angle.mp4";
import aiThetaProWideAnglePosterJpg from "../assets/related-addons/ai-theta-pro-wide-angle-poster.jpg";
import aiThetaProWideAngleLensPreviewPng from "../assets/related-addons/ai-theta-pro-wide-angle-lens-preview.png";
import aiThetaWideAngleMp4 from "../assets/related-addons/ai-theta-wide-angle.mp4";
import aiThetaWideAnglePosterJpg from "../assets/related-addons/ai-theta-wide-angle-poster.jpg";
import aiThetaLensPreviewPng from "../assets/related-addons/ai-theta-lens-preview.png";
import aiThetaPro360Mp4 from "../assets/related-addons/ai-theta-pro-360.mp4";
import aiThetaPro360PosterJpg from "../assets/related-addons/ai-theta-pro-360-poster.jpg";
import aiThetaPro360LensPreviewPng from "../assets/related-addons/ai-theta-pro-360-lens-preview.png";
import aiTheta360LensMp4 from "../assets/related-addons/ai-theta-360-lens.mp4";
import aiTheta360LensPosterJpg from "../assets/related-addons/ai-theta-360-lens-poster.jpg";
import aiTheta360LensPreviewPng from "../assets/related-addons/ai-theta-360-lens-preview.png";
import aiThetaAudioMp4 from "../assets/related-addons/ai-theta-audio.mp4";
import aiThetaAudioPosterJpg from "../assets/related-addons/ai-theta-audio-poster.jpg";
import aiThetaAudioPreviewPng from "../assets/related-addons/ai-theta-audio-preview.png";
import ptzPoleMountMp4 from "../assets/related-addons/ptz-pole-mount.mp4";
import ptzPoleMountPosterJpg from "../assets/related-addons/ptz-pole-mount-poster.jpg";
import ptzPoleMountPreviewPng from "../assets/related-addons/ptz-pole-mount-preview.png";
import ptzWallMountMp4 from "../assets/related-addons/ptz-wall-mount.mp4";
import ptzWallMountPosterJpg from "../assets/related-addons/ptz-wall-mount-poster.jpg";
import ptzWallMountPreviewPng from "../assets/related-addons/ptz-wall-mount-preview.png";
import ptzCornerMountMp4 from "../assets/related-addons/ptz-corner-mount.mp4";
import ptzCornerMountPosterJpg from "../assets/related-addons/ptz-corner-mount-poster.jpg";
import ptzCornerMountPreviewPng from "../assets/related-addons/ptz-corner-mount-preview.png";
import ptzConduitMountMp4 from "../assets/related-addons/ptz-conduit-mount.mp4";
import ptzConduitMountPosterJpg from "../assets/related-addons/ptz-conduit-mount-poster.jpg";
import ptzConduitAdapterPreviewPng from "../assets/related-addons/ptz-conduit-adapter-preview.png";
import ptzPendantMountMp4 from "../assets/related-addons/ptz-pendant-mount.mp4";
import ptzPendantMountPosterJpg from "../assets/related-addons/ptz-pendant-mount-poster.jpg";
import ptzPendantMountPreviewPng from "../assets/related-addons/ptz-pendant-mount-preview.png";
import ptzSurfaceMountMp4 from "../assets/related-addons/ptz-surface-mount.mp4";
import ptzSurfaceMountPosterJpg from "../assets/related-addons/ptz-surface-mount-poster.jpg";
import ptzSurfaceMountPreviewPng from "../assets/related-addons/ptz-surface-mount-preview.png";
import ptzInCeilingMountMp4 from "../assets/related-addons/ptz-in-ceiling-mount.mp4";
import ptzInCeilingMountPosterJpg from "../assets/related-addons/ptz-in-ceiling-mount-poster.jpg";
import ptzInCeilingMountPreviewPng from "../assets/related-addons/ptz-in-ceiling-mount-preview.png";
import ethernetSurgeProtectorMp4 from "../../../../assets/related-addons/shared/ethernet-surge-protector.mp4";
import ethernetSurgeProtectorJpg from "../../../../assets/related-addons/shared/ethernet-surge-protector.jpg";
import ethernetSurgeProtectorPreviewPng from "../assets/related-addons/ethernet-surge-protector-preview.png";
import poePlusPlusAdapter60wMp4 from "../assets/related-addons/poe-plus-plus-adapter-60w.mp4";
import poePlusPlusAdapter60wPosterJpg from "../assets/related-addons/poe-plus-plus-adapter-60w-poster.jpg";
import poePlusPlusAdapterPreviewPng from "../assets/related-addons/poe-plus-plus-adapter-preview.png";
import aiKeyRackMountMp4 from "../assets/related-addons/ai-key-rack-mount.mp4";
import aiKeyRackMountPosterJpg from "../assets/related-addons/ai-key-rack-mount-poster.jpg";
import aiKeyRackMountPreviewPng from "../assets/related-addons/ai-key-rack-mount-preview.png";
import aiPortRackMountMp4 from "../assets/related-addons/ai-port-rack-mount.mp4";
import aiPortRackMountPosterJpg from "../assets/related-addons/ai-port-rack-mount-poster.jpg";
import aiPortRackMountPreviewPng from "../assets/related-addons/ai-port-rack-mount-preview.png";
import universalTableStandMp4 from "../../../../assets/related-addons/shared/universal-table-stand.mp4";
import universalTableStandJpg from "../../../../assets/related-addons/shared/universal-table-stand.jpg";
import universalTableStandPreviewPng from "../assets/related-addons/universal-table-stand-preview.png";
import microSdCard128gbMp4 from "../../../../assets/related-addons/shared/micro-sd-card-128gb.mp4";
import microSdCard128gbJpg from "../../../../assets/related-addons/shared/micro-sd-card-128gb.jpg";
import microSdCardPreviewPng from "../assets/related-addons/micro-sd-card-preview.png";
import nanoThinHdmiCableMp4 from "../assets/related-addons/nano-thin-hdmi-cable.mp4";
import nanoThinHdmiCablePosterJpg from "../assets/related-addons/nano-thin-hdmi-cable-poster.jpg";
import nanoThinHdmiCablePreviewPng from "../assets/related-addons/nano-thin-hdmi-cable-preview.png";
import g4DoorbellProCoverMp4 from "../assets/related-addons/g4-doorbell-pro-cover.mp4";
import g4DoorbellProCoverPosterJpg from "../assets/related-addons/g4-doorbell-pro-cover-poster.jpg";
import g4DoorbellProCoverPreviewPng from "../assets/related-addons/g4-doorbell-pro-cover-preview.png";
import g4DoorbellProPoeGangBoxMp4 from "../assets/related-addons/g4-doorbell-pro-poe-gang-box.mp4";
import g4DoorbellProPoeGangBoxPosterJpg from "../assets/related-addons/g4-doorbell-pro-poe-gang-box-poster.jpg";
import g4DoorbellProPoeGangBoxMountPreviewPng from "../assets/related-addons/g4-doorbell-pro-poe-gang-box-mount-preview.png";
import readerProJunctionBoxMp4 from "../assets/related-addons/reader-pro-junction-box.mp4";
import readerProJunctionBoxPosterJpg from "../assets/related-addons/reader-pro-junction-box-poster.jpg";
import readerProJunctionBoxPreviewPng from "../assets/related-addons/reader-pro-junction-box-preview.png";
import wifiSmartChimeMp4 from "../assets/related-addons/wifi-smart-chime.mp4";
import wifiSmartChimePosterJpg from "../assets/related-addons/wifi-smart-chime-poster.jpg";
import wifiSmartChimePreviewPng from "../assets/related-addons/wifi-smart-chime-preview.png";
import poeSmartChimeMp4 from "../assets/related-addons/poe-smart-chime.mp4";
import poeSmartChimePosterJpg from "../assets/related-addons/poe-smart-chime-poster.jpg";
import g4DoorbellProAcAdapterMp4 from "../assets/related-addons/g4-doorbell-pro-ac-adapter.mp4";
import g4DoorbellProAcAdapterPosterJpg from "../assets/related-addons/g4-doorbell-pro-ac-adapter-poster.jpg";
import g4DoorbellProAcAdapterPreviewPng from "../assets/related-addons/g4-doorbell-pro-ac-adapter-preview.png";
import envrBezelMp4 from "../assets/related-addons/envr-bezel.mp4";
import envrBezelPosterJpg from "../assets/related-addons/envr-bezel-poster.jpg";
import enterpriseNvrBezelPreviewPng from "../assets/related-addons/enterprise-nvr-bezel-preview.png";
import protectViewportMp4 from "../assets/related-addons/protect-viewport.mp4";
import protectViewportPosterJpg from "../assets/related-addons/protect-viewport-poster.jpg";
import protectViewportPreviewPng from "../assets/related-addons/protect-viewport-preview.png";
import enterpriseHddMp4 from "../../../../assets/related-addons/shared/enterprise-hdd.mp4";
import enterpriseHddJpg from "../../../../assets/related-addons/shared/enterprise-hdd.jpg";
import hddStoragePreviewPng from "../assets/related-addons/hdd-storage-preview.png";
import toollessMiniRackMp4 from "../../../../assets/related-addons/shared/toolless-mini-rack.mp4";
import toollessMiniRackJpg from "../../../../assets/related-addons/shared/toolless-mini-rack.jpg";
import toollessMiniRackPreviewPng from "../assets/related-addons/toolless-mini-rack-preview.png";
import lteBackupProMp4 from "../../../../assets/related-addons/shared/lte-backup-pro.mp4";
import lteBackupProJpg from "../../../../assets/related-addons/shared/lte-backup-pro.jpg";
import lteBackupProPreviewPng from "../assets/related-addons/lte-backup-pro-preview.png";
import powerBackupMp4 from "../../../../assets/related-addons/shared/power-backup.mp4";
import powerBackupPreviewJpg from "../../../../assets/related-addons/shared/power-backup-preview.jpg";
import powerBackupPreviewPng from "../assets/related-addons/power-backup-preview.png";
import powerDistributionProMp4 from "../../../../assets/related-addons/shared/power-distribution-pro.mp4";
import powerDistributionProJpg from "../../../../assets/related-addons/shared/power-distribution-pro.jpg";
import powerDistributionProPreviewPng from "../assets/related-addons/power-distribution-pro-preview.png";
import rackMountOcdPanelsMp4 from "../../../../assets/related-addons/shared/rack-mount-ocd-panels.mp4";
import rackMountOcdPanelsJpg from "../../../../assets/related-addons/shared/rack-mount-ocd-panels.jpg";
import rackMountOcdPanelsPreviewPng from "../assets/related-addons/rack-mount-ocd-panels-preview.png";
import blankKeystonePatchPanelMp4 from "../../../../assets/related-addons/shared/_24-port-blank-keystone-patch-panel.mp4";
import blankKeystonePatchPanelPosterJpg from "../../../../assets/related-addons/shared/_24-port-blank-keystone-patch-panel-poster.jpg";
import blankKeystonePatchPanelPreviewPng from "../assets/related-addons/24-port-blank-keystone-patch-panel-preview.png";
import powerDistributionHiDensityMp4 from "../../../../assets/related-addons/shared/power-distribution-hi-density.mp4";
import powerDistributionHiDensityJpg from "../../../../assets/related-addons/shared/power-distribution-hi-density.jpg";
import powerDistributionHiDensityPreviewPng from "../assets/related-addons/power-distribution-hi-density-preview.png";
import cloudkeyPlusStandMp4 from "../assets/related-addons/cloudkey-plus-stand.mp4";
import cloudkeyPlusStandPosterJpg from "../assets/related-addons/cloudkey-plus-stand-poster.jpg";
import cloudkeyPlusStandPreviewPng from "../assets/related-addons/cloudkey-plus-stand-preview.png";

export const INSTALLATION_ADDONS = [
  // Dome Turret
  {
    id: "CameraDualMount", // TODO: Move to ENUM
    title: "installationAddons.cameraDualMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.AiDome, label: "AI Dome" },
      { id: BuildFeatureItemId.G5TurretUltra, label: "G5 Turret Ultra" },
      { id: BuildFeatureItemId.G5DomeUltra, label: "G5 Dome Ultra" },
      { id: BuildFeatureItemId.G6Dome, label: "G6 Dome" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "260 x 118 x 103 mm",
        dimensionsInches: '(10.2 x 4.6 x 4.1")',
      },
    ],
    description: "installationAddons.cameraDualMount.description",
    video: {
      src: cameraDualMountMp4,
      poster: cameraDualMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-camera-dm`,
    },
    previewImg: cameraDualMountPreviewPng,
  },
  {
    id: "AIDomeCameraFlushMount", // TODO: Move to ENUM
    title: "installationAddons.aiDomeCameraFlushMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.AiDome, label: "AI Dome" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø158 x 75 mm",
        dimensionsInches: '(Ø6.2 x 3")',
      },
    ],
    description: "installationAddons.aiDomeCameraFlushMount.description",
    video: {
      src: aiDomeCameraFlushmountMp4,
      poster: aiDomeCameraFlushmountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-dome-fm`,
    },
    previewImg: aiDomeCameraFlushMountPreviewPng,
  },
  {
    id: "DomeCameraWeatherShield", // TODO: Move to ENUM
    title: "installationAddons.domeCameraWeatherShield.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.AiDome, label: "AI Dome" }],
    dimensions: [
      {
        dimensionsMillimeters: "122 x 119.5 x 114.1 mm",
        dimensionsInches: '(4.8 x 4.7 x 4.5")',
      },
    ],
    description: "installationAddons.domeCameraWeatherShield.description",
    video: {
      src: domeCameraWeatherShieldMp4,
      poster: domeCameraWeatherShieldPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-dome-ws`,
    },
    previewImg: domeCameraWeatherShieldPreviewPng,
  },
  {
    id: "CameraCompactJunctionBox",
    title: "installationAddons.cameraCompactJunctionBox.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.G5TurretUltra, label: "G5 Turret Ultra" },
      { id: BuildFeatureItemId.G5DomeUltra, label: "G5 Dome Ultra" },
    ],
    dimensions: [
      {
        label: "installationAddons.cameraCompactJunctionBox.long.dim.label",
        dimensionsMillimeters: "87 x 147 x 49 mm",
        dimensionsInches: '(3.4 x 5.8 x 1.9")',
      },
      {
        label: "installationAddons.cameraCompactJunctionBox.short.dim.label",
        dimensionsMillimeters: "87 x 110 x 49 mm",
        dimensionsInches: '(3.4 x 4.3 x 1.9")',
      },
    ],
    description: "installationAddons.cameraCompactJunctionBox.description",
    video: {
      src: compactCameraJunctionBoxMp4,
      poster: compactCameraJunctionBoxPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/other/uacc-camera-cjb`,
    },
    previewImg: cameraCompactJunctionBoxPreviewPng,
  },
  {
    id: "CameraArmMount",
    title: "installationAddons.cameraArmMount.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5TurretUltra, label: "G5 Turret Ultra" }],
    dimensions: [
      {
        dimensionsMillimeters: "115 x 252 x 90 mm",
        dimensionsInches: '(4.5 x 9.9 x 3.5")',
      },
    ],
    description: "installationAddons.cameraArmMount.description",
    video: {
      src: g5TurretUltraCameraMountMp4,
      poster: g5TurretUltraCameraMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-camera-am`,
    },
    previewImg: cameraArmMountPreviewPng,
  },
  {
    id: "G5DomeUltraFlushMount",
    title: "installationAddons.g5DomeUltraFlushMount.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5DomeUltra, label: "G5 Dome Ultra" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø100 x 88 mm",
        dimensionsInches: '(Ø4 x 3.5")',
      },
    ],
    description: "installationAddons.g5DomeUltraFlushMount.description",
    video: {
      src: g5DomeUltraFlushMountMp4,
      poster: g5DomeUltraFlushMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-g5-dome-ultra-fm`,
    },
    previewImg: g5DomeUltraFlushMountPreviewPng,
  },
  {
    id: "CameraJunctionBox",
    title: "installationAddons.cameraJunctionBox.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.AiDome, label: "AI Dome" },
      { id: BuildFeatureItemId.G6Turret, label: "G6 Turret" },
      { id: BuildFeatureItemId.G6Dome, label: "G6 Dome" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "Ø140.4 x 59.7 mm",
        dimensionsInches: '(Ø5.5 x 2.4")',
      },
    ],
    description: "installationAddons.cameraJunctionBox.description",
    video: {
      src: cameraJunctionBoxMp4,
      poster: cameraJunctionBoxPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-camera-jb`,
    },
    previewImg: cameraJunctionBoxPreviewPng,
  },
  {
    id: "AI360JunctionBox",
    title: "installationAddons.ai360junctionBox.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.Ai360, label: "AI 360" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø173.2 x 76 mm",
        dimensionsInches: '(Ø6.8 x 3")',
      },
    ],
    description: "installationAddons.ai360junctionBox.description",
    video: {
      src: ai360JunctionBoxMp4,
      poster: ai360JunctionBoxPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-ai-360-jb`,
    },
    previewImg: ai360JunctionBoxPreviewPng,
  },
  {
    id: "DomeCameraArmMount",
    title: "installationAddons.domeCameraArmMount.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.G5Dome, label: "G5 Dome" },
      { id: BuildFeatureItemId.G6Dome, label: "G6 Dome" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "123.8 x 114 x 31.5 mm",
        dimensionsInches: '(4.87 x 4.49 x 1.24")',
      },
    ],
    description: "installationAddons.domeCameraArmMount.description",
    video: {
      src: domeCameraArmMountMp4,
      poster: domeCameraArmMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/g4-dome-arm-mount`,
    },
    previewImg: domeCameraArmMountPreviewPng,
  },
  // Bullet
  {
    id: "CameraAngledBase",
    title: "installationAddons.bulletCameraAngledBase.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    dimensions: [
      {
        dimensionsMillimeters: "Ø62 x 55 mm",
        dimensionsInches: '(Ø2.4 x 2.2")',
      },
    ],
    tags: [
      { id: BuildFeatureItemId.AiPro, label: "AI Pro" },
      { id: BuildFeatureItemId.G5Pro, label: "G5 Pro" },
    ],
    description: "installationAddons.bulletCameraAngledBase.description",
    video: {
      src: bulletCameraAngledBaseMp4,
      poster: bulletCameraAngledBasePosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-bullet-ab`,
    },
    previewImg: bulletCameraAngledBasePreviewPng,
  },
  {
    id: "BulletCameraJunctionBox",
    title: "installationAddons.cameraJunctionBox.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.AiPro, label: "AI Pro" },
      { id: BuildFeatureItemId.G6Bullet, label: "G6 Bullet" },
      { id: BuildFeatureItemId.AiDSLR, label: "AI DSLR" },
      { id: BuildFeatureItemId.G5Pro, label: "G5 Pro" },
      { id: BuildFeatureItemId.G5Bullet, label: "G5 Bullet" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "Ø140.4 x 59.7 mm",
        dimensionsInches: '(Ø5.5 x 2.4")',
      },
    ],
    description: "installationAddons.cameraJunctionBox.description",
    video: {
      src: bulletCameraJunctionBoxMp4,
      poster: bulletCameraJunctionBoxJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-camera-jb`,
    },
    previewImg: cameraJunctionBoxPreviewPng,
  },
  {
    id: "AIEnhancer",
    title: "installationAddons.bulletAiEnhancer.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.AiPro, label: "AI Pro" },
      // TODO: probably add the enum below
      { id: BuildFeatureItemId.G5Pro, label: "G5 Pro" },
      // TODO: probably add the enum below
      // { id: BuildFeatureItemId.G4Pro, label: "G4 Pro" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "130 x 155 x 126 mm",
        dimensionsInches: '(5.1 x 6.1 x 5")',
      },
    ],
    description: "installationAddons.bulletAiEnhancer.description",
    video: {
      src: aiEnhancerMp4,
      poster: aiEnhancerJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-ai-pro-enhancer`,
    },
    previewImg: aiEnhancerPreviewPng,
  },
  {
    id: "G5ProEnhancer",
    title: "installationAddons.g5ProEnhancer.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5Pro, label: "G5 Pro" }],
    description: "installationAddons.g5ProEnhancer.description",
    dimensions: [
      {
        dimensionsMillimeters: "Ø118.5 x 103.3 mm",
        dimensionsInches: '(Ø4.7 x 4.1")',
      },
    ],
    video: {
      src: g5ProEnhancerMp4,
      poster: g5ProEnhancerPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/other/uacc-g5-enhancer`,
    },
    previewImg: g5ProEnhancerPreviewPng,
  },
  // Compact
  {
    id: "FlexProMount",
    title: "installationAddons.flexProMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5Flex, label: "G5 Flex" }],
    dimensions: [
      {
        dimensionsMillimeters: "133.5 x 52 x 62 mm",
        dimensionsInches: '(5.3 x 2.1 x 2.4")',
      },
    ],
    description: "installationAddons.flexProMount.description",
    video: {
      src: flexProMountMp4,
      poster: flexProMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-flex-cam-pwm`,
    },
    previewImg: flexProMountPreviewPng,
  },
  {
    id: "FlexInCeilingMount",
    title: "installationAddons.flexCeilingMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5Flex, label: "G5 Flex" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø88.3 x 67.8 mm",
        dimensionsInches: '(Ø3.5 x 2.7")',
      },
    ],
    description: "installationAddons.flexCeilingMount.description",
    video: {
      src: flexInCeilingMountMp4,
      poster: flexInCeilingMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uvc-g3-f-c`,
    },
    previewImg: flexInCeilingMountPreviewPng,
  },
  {
    id: "FlexPendantMount",
    title: "installationAddons.flexPendantMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5Flex, label: "G5 Flex" }],
    description: "installationAddons.flexPendantMount.description",
    dimensions: [
      {
        dimensionsMillimeters: "67.7 x 60 x 53.6 mm",
        dimensionsInches: '(2.7 x 2.4 x 2.1")',
      },
    ],
    video: {
      src: flexPendantMountMp4,
      poster: flexPendantMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uvc-g3-f-pendant`,
    },
    previewImg: flexPendantMountPreviewPng,
  },
  {
    id: "G4InstantCover",
    title: "installationAddons.g4InstantCover.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G4Instant, label: "G4 Instant" }],
    description: "installationAddons.g4InstantCover.description",
    dimensions: [
      {
        dimensionsMillimeters: "82 x 52 x 49 mm",
        dimensionsInches: '(3.2 x 2.1 x 1.9")',
      },
    ],
    video: {
      src: g4InstantCoverMp4,
      poster: g4InstantCoverPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/unifi-g4-instant-cover`,
    },
    previewImg: g4InstantCoverPreviewPng,
  },
  // Interior Design
  {
    id: "AIThetaProAngleMount",
    title: "installationAddons.aiThetaProAngleMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.AiThetaPro, label: "AI Theta Pro" }],
    dimensions: [
      {
        dimensionsMillimeters: "49.7 x 42.4 x 76.2 mm",
        dimensionsInches: '(2 x 1.7 x 3")',
      },
    ],
    description: "installationAddons.aiThetaProAngleMount.description",
    video: {
      src: aiThetaProAngleMountMp4,
      poster: aiThetaProAngleMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-ai-theta-pro-angle-mount-camera`,
    },
    previewImg: aiThetaProAngleMountPreviewPng,
  },
  {
    id: "AIThetaAngleMount",
    title: "installationAddons.aiThetaAngleMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.AiTheta, label: "AI Theta" }],
    dimensions: [
      {
        dimensionsMillimeters: "49.7 x 42.4 x 76.2 mm",
        dimensionsInches: '(2 x 1.7 x 3")',
      },
    ],
    description: "installationAddons.aiThetaAngleMount.description",
    video: {
      src: aiThetaAngleMountMp4,
      poster: aiThetaAngleMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-ai-theta-angle-mount-camera`,
    },
    previewImg: aiThetaAngleMountPreviewPng,
  },
  {
    id: "AIThetaProFlushMount",
    title: "installationAddons.aiThetaProFlushMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.AiThetaPro, label: "AI Theta Pro" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø73.6 x 73.7 mm",
        dimensionsInches: '(Ø2.9 x 2.9")',
      },
    ],
    description: "installationAddons.aiThetaProFlushMount.description",
    video: {
      src: aiThetaProFlushMountMp4,
      poster: aiThetaProFlushMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-ai-theta-pro-pfm-camera`,
    },
    previewImg: aiThetaProFlushMountPreviewPng,
  },
  {
    id: "AIThetaCeilingMountSystem",
    title: "installationAddons.aiThetaCeilingMountSystem.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.AiThetaPro, label: "AI Theta Pro" },
      { id: BuildFeatureItemId.AiTheta, label: "AI Theta" },
    ],
    description: "installationAddons.aiThetaCeilingMountSystem.description",
    dimensions: [
      {
        dimensionsMillimeters: "240 x 140 x 5 mm",
        dimensionsInches: '(9.5 x 5.5 x 0.2")',
      },
    ],
    video: {
      src: aiThetaCeilingMountMp4,
      poster: aiThetaCeilingMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-ai-theta-cms`,
    },
    previewImg: aiThetaCeilingMountSystemPreviewPng,
  },
  {
    id: "AIThetaProLongDistanceLens",
    title: "installationAddons.aiThetaProLongDistanceLens.title",
    category: "installationAddons.aiThetaHub.label",
    dimensions: [
      {
        dimensionsMillimeters: "Ø36.6 x 58.9 mm",
        dimensionsInches: "(Ø1.4 x 2.3”)",
      },
    ],
    shouldDisplayTagNames: false,
    tags: [{ id: BuildFeatureItemId.AiThetaPro, label: "AI Theta Pro" }],
    description: "installationAddons.aiThetaProLongDistanceLens.description",
    video: {
      src: aiThetaProLrMp4,
      poster: aiThetaProLrPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uvc-ai-theta-prolens50`,
    },
    previewImg: aiThetaProLongDistanceLensPreviewPng,
  },
  {
    id: "AIThetaLongDistanceLens",
    title: "installationAddons.aiThetaLongDistanceLens.title",
    category: "installationAddons.aiThetaHub.label",
    shouldDisplayTagNames: false,
    tags: [{ id: BuildFeatureItemId.AiTheta, label: "AI Theta" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø22.8. x 43.5 mm",
        dimensionsInches: "(Ø0.9 x 1.7”)",
      },
    ],
    description: "installationAddons.aiThetaLongDistanceLens.description",
    video: {
      src: aiThetaLrLensMp4,
      poster: aiThetaLrLensPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uvc-ai-theta-lens-ld`,
    },
    previewImg: aiThetaLongDistanceLensPreviewPng,
  },
  {
    id: "AIThetaProWideAngleLens",
    title: "installationAddons.aiThetaProWideAngleLens.title",
    category: "installationAddons.aiThetaHub.label",
    shouldDisplayTagNames: false,
    tags: [{ id: BuildFeatureItemId.AiThetaPro, label: "AI Theta Pro" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø36.6 x 58.9 mm",
        dimensionsInches: "(Ø1.4 x 2.3”)",
      },
    ],
    description: "installationAddons.aiThetaProWideAngleLens.description",
    video: {
      src: aiThetaProWideAngleMp4,
      poster: aiThetaProWideAnglePosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uvc-ai-theta-prolens110`,
    },
    previewImg: aiThetaProWideAngleLensPreviewPng,
  },
  {
    id: "AIThetaWideAngleLens",
    title: "installationAddons.aiThetaWideAngleLens.title",
    category: "installationAddons.aiThetaHub.label",
    shouldDisplayTagNames: false,
    tags: [{ id: BuildFeatureItemId.AiTheta, label: "AI Theta" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø22.8. x 43.5 mm",
        dimensionsInches: "(Ø0.9 x 1.7”)",
      },
    ],
    description: "installationAddons.aiThetaWideAngleLens.description",
    video: {
      src: aiThetaWideAngleMp4,
      poster: aiThetaWideAnglePosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uvc-ai-theta-lens`,
    },
    previewImg: aiThetaLensPreviewPng,
  },
  {
    id: "AIThetaPro360Lens",
    title: "installationAddons.aiThetaPro360Lens.title",
    category: "installationAddons.aiThetaHub.label",
    shouldDisplayTagNames: false,
    tags: [{ id: BuildFeatureItemId.AiThetaPro, label: "AI Theta Pro" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø36.6 x 58.9 mm",
        dimensionsInches: "(Ø1.4 x 2.3”)",
      },
    ],
    description: "installationAddons.aiThetaPro360Lens.description",
    video: {
      src: aiThetaPro360Mp4,
      poster: aiThetaPro360PosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uvc-ai-theta-prolens360`,
    },
    previewImg: aiThetaPro360LensPreviewPng,
  },
  {
    id: "AITheta360Lens",
    title: "installationAddons.aiTheta360Lens.title",
    category: "installationAddons.aiThetaHub.label",
    shouldDisplayTagNames: false,
    tags: [{ id: BuildFeatureItemId.AiTheta, label: "AI Theta" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø22.8. x 43.5 mm",
        dimensionsInches: "(Ø0.9 x 1.7”)",
      },
    ],
    description: "installationAddons.aiTheta360Lens.description",
    video: {
      src: aiTheta360LensMp4,
      poster: aiTheta360LensPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uvc-ai-theta-lens-360`,
    },
    previewImg: aiTheta360LensPreviewPng,
  },
  {
    id: "AIThetaAudio",
    title: "installationAddons.aiThetaAudio.title",
    category: "installationAddons.aiThetaHub.label",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.AiThetaPro, label: "AI Theta Pro" },
      { id: BuildFeatureItemId.AiTheta, label: "AI Theta" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "Ø61.5 x 39 mm",
        dimensionsInches: '(Ø2.4 x 1.5")',
      },
    ],
    description: "installationAddons.aiThetaAudio.description",
    video: {
      src: aiThetaAudioMp4,
      poster: aiThetaAudioPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uvc-ai-theta-audio`,
    },
    previewImg: aiThetaAudioPreviewPng,
  },
  // PTZ
  {
    id: "PoleMount",
    title: "installationAddons.ptzPoleMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" }],
    description: "installationAddons.ptzPoleMount.description",
    video: {
      src: ptzPoleMountMp4,
      poster: ptzPoleMountPosterJpg,
    },
    previewImg: ptzPoleMountPreviewPng,
  },
  {
    id: "WallMount",
    title: "installationAddons.ptzWallMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" }],
    description: "installationAddons.ptzWallMount.description",
    video: {
      src: ptzWallMountMp4,
      poster: ptzWallMountPosterJpg,
    },
    previewImg: ptzWallMountPreviewPng,
  },
  {
    id: "CornerMount",
    title: "installationAddons.ptzCornerMount.title",
    category: "commons.accessory",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" }],
    dimensions: [
      {
        dimensionsMillimeters: "91.1 x 42.2 x 48.2 mm",
        dimensionsInches: '(3.6 x 1.7 x 1.9")',
      },
    ],
    description: "installationAddons.ptzCornerMount.description",
    video: {
      src: ptzCornerMountMp4,
      poster: ptzCornerMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-g5-ptz-cm`,
    },
    previewImg: ptzCornerMountPreviewPng,
  },
  {
    id: "ConduitAdapter",
    title: "installationAddons.ptzConduitAdapter.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" }],
    dimensions: [
      {
        dimensionsMillimeters: "95.5 x 61 x 52.2 mm",
        dimensionsInches: '(3.8 x 2.4 x 2.1")',
      },
    ],
    description: "installationAddons.ptzConduitAdapter.description",
    video: {
      src: ptzConduitMountMp4,
      poster: ptzConduitMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-g5-ptz-ca`,
    },
    previewImg: ptzConduitAdapterPreviewPng,
  },
  {
    id: "PendantMount",
    title: "installationAddons.ptzPendantMount.title",
    category: "commons.accessory",
    shouldDisplayTagNames: true,
    description: "installationAddons.ptzPendantMount.description",
    dimensions: [
      {
        dimensionsMillimeters: "Ø61 x 43.4 mm",
        dimensionsInches: '(Ø2.4 x 1.7")',
      },
    ],
    tags: [{ id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" }],
    video: {
      src: ptzPendantMountMp4,
      poster: ptzPendantMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-g5-ptz-pm`,
    },
    previewImg: ptzPendantMountPreviewPng,
  },
  {
    id: "SurfaceMount",
    title: "installationAddons.ptzSurfaceMount.title",
    category: "commons.accessory",
    shouldDisplayTagNames: true,
    description: "installationAddons.ptzSurfaceMount.description",
    tags: [{ id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" }],
    dimensions: [
      {
        dimensionsMillimeters: "Ø90 x 46.7 mm",
        dimensionsInches: '(Ø3.5 x 1.8")',
      },
    ],
    video: {
      src: ptzSurfaceMountMp4,
      poster: ptzSurfaceMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-g5-ptz-sm`,
    },
    previewImg: ptzSurfaceMountPreviewPng,
  },
  {
    id: "InCeilingMount",
    title: "installationAddons.ptzCeilingMount.title",
    category: "commons.accessory",
    shouldDisplayTagNames: true,
    description: "installationAddons.ptzCeilingMount.description",
    dimensions: [
      {
        dimensionsMillimeters: "Ø109.5 x 94.7 mm",
        dimensionsInches: '(Ø4.3 x 3.7")',
      },
    ],
    tags: [{ id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" }],
    video: {
      src: ptzInCeilingMountMp4,
      poster: ptzInCeilingMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-g5-ptz-icm`,
    },
    previewImg: ptzInCeilingMountPreviewPng,
  },
  {
    id: "EthernetSurgeProtector",
    title: "installationAddons.ethernetSurgeProtector.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.AiLPR, label: "AI LPR" },
      { id: BuildFeatureItemId.AiDSLR, label: "AI DSLR" },
      { id: BuildFeatureItemId.AiPro, label: "AI Pro" },
      { id: BuildFeatureItemId.G5Bullet, label: "G5 Bullet" },
      { id: BuildFeatureItemId.G5Pro, label: "G5 Pro" },
      { id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" },
      { id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" },
      { id: BuildFeatureItemId.AIHorn, label: "AI Horn" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "91 x 61 x 32.5 mm",
        dimensionsInches: '(3.6 x 2.4 x 1.3")',
      },
    ],
    description: "installationAddons.ethernetSurgeProtector.description",
    video: {
      src: ethernetSurgeProtectorMp4,
      poster: ethernetSurgeProtectorJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/ethernet-surge-protector`,
    },
    previewImg: ethernetSurgeProtectorPreviewPng,
  },
  {
    id: "PoE++Adapter",
    title: "installationAddons.poePlusPlusAdapter.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [{ id: BuildFeatureItemId.G5Ptz, label: "G5 PTZ" }],
    dimensions: [
      {
        dimensionsMillimeters: "106 x 63 x 34 mm",
        dimensionsInches: '(4.2 x 2.5 x 1.3")',
      },
    ],
    description: "installationAddons.poePlusPlusAdapter.description",
    video: {
      src: poePlusPlusAdapter60wMp4,
      poster: poePlusPlusAdapter60wPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/u-poe-plus-plus`,
    },
    previewImg: poePlusPlusAdapterPreviewPng,
  },
  // Special Devices
  {
    id: "AIKeyRackMount",
    title: "installationAddons.aiKeyRackMount.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.AiKey, label: "AI Key" }],
    dimensions: [
      {
        dimensionsMillimeters: "464.4 x 56 x 43.7 mm",
        dimensionsInches: '(18.3 x 2.2 x 1.7")',
      },
    ],
    description: "installationAddons.aiKeyRackMount.description",
    video: {
      src: aiKeyRackMountMp4,
      poster: aiKeyRackMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-ai-key-rm`,
    },
    previewImg: aiKeyRackMountPreviewPng,
  },
  {
    id: "AIPortRackMount",
    title: "installationAddons.aiPortRackMount.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.AiPort, label: "AI Port" }],
    dimensions: [
      {
        dimensionsMillimeters: "442.4 x 158.5 x 42.8 mm",
        dimensionsInches: '(17.4 x 6.2 x 1.7")',
      },
    ],
    description: "installationAddons.aiPortRackMount.description",
    video: {
      src: aiPortRackMountMp4,
      poster: aiPortRackMountPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-ai-port-rm`,
    },
    previewImg: aiPortRackMountPreviewPng,
  },
  {
    id: "UniversalTableStand",
    title: "installationAddons.universalTableStand.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.AiKey, label: "AI Key" }],
    dimensions: [
      {
        dimensionsMillimeters: "125.2 x 73.2 x 70.5 mm",
        dimensionsInches: '(4.9 x 2.9 x 2.8")',
      },
    ],
    description: "installationAddons.universalTableStand.description",
    video: {
      src: universalTableStandMp4,
      poster: universalTableStandJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-uts`,
    },
    previewImg: universalTableStandPreviewPng,
  },
  {
    id: "MicroSdCard",
    title: "installationAddons.microSdCard.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.ProtectViewport, label: "Protect Viewport" },
      { id: BuildFeatureItemId.AiPort, label: "AI Port" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "15 x 11 x 1 mm",
        dimensionsInches: '(5.75 x 4 x 1")',
      },
    ],
    description: "installationAddons.microSdCard.description",
    video: {
      src: microSdCard128gbMp4,
      poster: microSdCard128gbJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/msd`,
    },
    previewImg: microSdCardPreviewPng,
  },
  {
    id: "NanoThinHdmiCable",
    title: "installationAddons.nanoThinHdmiCable.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.ProtectViewport, label: "Protect Viewport" },
    ],
    description: "installationAddons.nanoThinHdmiCable.description",
    dimensions: [
      {
        dimensionsMillimeters: "1 m",
        dimensionsInches: "(3.3 ft)",
      },
    ],
    video: {
      src: nanoThinHdmiCableMp4,
      poster: nanoThinHdmiCablePosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-cable-uhs`,
    },
    previewImg: nanoThinHdmiCablePreviewPng,
  },
  /** DOORBELLS: */
  {
    id: "G4DoorbellProCover",
    title: "installationAddons.g4DoorbellProCover.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G4DoorbellPro, label: "G4 Doorbell Pro" }],
    dimensions: [
      {
        label: "installationAddons.g4DoorbellProCover.cover.dimension.label",
        dimensionsMillimeters: "164 x 55 x 21 mm",
        dimensionsInches: '(6.5 x 2.2 x 0.8")',
      },
      {
        label: "installationAddons.g4DoorbellProCover.wedge.dimension.label",
        dimensionsMillimeters: "164 x 55 x 26 mm",
        dimensionsInches: '(6.5 x 2.2 x 1")',
      },
    ],
    description: "installationAddons.g4DoorbellProCover.description",
    video: {
      src: g4DoorbellProCoverMp4,
      poster: g4DoorbellProCoverPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/other/uacc-g4-doorbell-pro-cover`,
    },
    previewImg: g4DoorbellProCoverPreviewPng,
  },
  {
    id: "G4DoorbellProPoEGangBoxMount",
    title: "installationAddons.g4DoorbellGangBoxMount.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G4DoorbellPro, label: "G4 Doorbell Pro" }],
    description: "installationAddons.g4DoorbellGangBoxMount.description",
    dimensions: [
      {
        label:
          "installationAddons.g4DoorbellGangBoxMount.gangBox.dimension.label",
        dimensionsMillimeters: "178.7 x 72 x 2.9 mm",
        dimensionsInches: '(7 x 2.8 x 0.1")',
      },
      {
        label:
          "installationAddons.g4DoorbellGangBoxMount.metal.dimension.label",
        dimensionsMillimeters: "184.9 x 78.2 x 13 mm",
        dimensionsInches: '(7.3 x 3.1 x 0.5")',
      },
      /** THIS OVERFLOWS THE CONTAINER */
      // {
      //   label:
      //     "installationAddons.g4DoorbellGangBoxMount.metalWedge.dimension.label",
      //   dimensionsMillimeters: "184.9 x 78.2 x 28 mm",
      //   dimensionsInches: '(7.3 x 3.1 x 1.1")',
      // },
    ],
    video: {
      src: g4DoorbellProPoeGangBoxMp4,
      poster: g4DoorbellProPoeGangBoxPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-g4-doorbell-pro-poe-gang-box`,
    },
    previewImg: g4DoorbellProPoeGangBoxMountPreviewPng,
  },
  {
    id: "ReaderProJunctionBox",
    title: "installationAddons.readerProJunctionBox.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.G4DoorbellPro, label: "G4 Doorbell Pro" },
      { id: BuildFeatureItemId.G3ReaderPro, label: "G3 Reader Pro" },
    ],
    description: "installationAddons.readerProJunctionBox.description",
    dimensions: [
      {
        dimensionsMillimeters: "205.4 x 77.8 x 48.6 mm",
        dimensionsInches: '(8.1 x 3.1 x 1.9")',
      },
    ],
    video: {
      src: readerProJunctionBoxMp4,
      poster: readerProJunctionBoxPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/door-access/uacc-reader-pro-jb`,
    },
    previewImg: readerProJunctionBoxPreviewPng,
  },
  {
    id: "WifiSmartChime",
    title: "installationAddons.smartChime.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.G4DoorbellPro, label: "G4 Doorbell Pro" },
      { id: BuildFeatureItemId.G3ReaderPro, label: "G3 Reader Pro" },
      { id: BuildFeatureItemId.Intercom, label: "Intercom" },
    ],
    description: "installationAddons.smartChime.description",
    dimensions: [
      {
        dimensionsMillimeters: "Ø62 x 50.6 mm",
        dimensionsInches: '(Ø2.4 x 2")',
      },
      // EU Version:
      // {
      //   dimensionsMillimeters: "Ø62 x 68.3 mm",
      //   dimensionsInches: '(Ø2.4 x 2.7")',
      // },
    ],
    video: {
      src: wifiSmartChimeMp4,
      poster: wifiSmartChimePosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/up-chime-us`,
    },
    previewImg: wifiSmartChimePreviewPng,
  },
  {
    id: "PoESmartChime",
    title: "installationAddons.poeSmartChime.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.G4DoorbellPro, label: "G4 Doorbell Pro" },
      { id: BuildFeatureItemId.G3ReaderPro, label: "G3 Reader Pro" },
      { id: BuildFeatureItemId.Intercom, label: "Intercom" },
    ],
    description: "installationAddons.poeSmartChime.description",
    dimensions: [
      {
        dimensionsMillimeters: "Ø62 x 54 mm",
        dimensionsInches: '(Ø2.5 x 2.1")',
      },
    ],
    video: {
      src: poeSmartChimeMp4,
      poster: poeSmartChimePosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-chime-poe`,
    },
    previewImg: wifiSmartChimePreviewPng,
  },
  {
    id: "G4DoorbellProAcAdapter",
    title: "installationAddons.g4DoorbellProAcAdapter.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.G4DoorbellPro, label: "G4 Doorbell Pro" }],
    description: "installationAddons.g4DoorbellProAcAdapter.description",
    video: {
      src: g4DoorbellProAcAdapterMp4,
      poster: g4DoorbellProAcAdapterPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/other/uacc-adapter-dbac-us`,
    },
    previewImg: g4DoorbellProAcAdapterPreviewPng,
  },
  // VideoRecorders
  {
    id: "EnterpriseNVRBezel",
    title: "installationAddons.enterpriseNvrBezel.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" }],
    dimensions: [
      {
        dimensionsMillimeters: "441.7 x 132 x 51.9 mm",
        dimensionsInches: '(17.4 x 5.2 x 2")',
      },
    ],
    description: "installationAddons.enterpriseNvrBezel.description",
    video: {
      src: envrBezelMp4,
      poster: envrBezelPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-envr-bezel`,
    },
    previewImg: enterpriseNvrBezelPreviewPng,
  },
  {
    id: "ProtectViewport",
    title: "installationAddons.protectViewport.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" },
      { id: BuildFeatureItemId.NvrPro, label: "UNVR Pro" },
      { id: BuildFeatureItemId.Nvr, label: "UNVR" },
      { id: BuildFeatureItemId.CloudKeyPlus, label: "CloudKey+" },
    ],
    description: "installationAddons.protectViewport.description",
    dimensions: [
      {
        dimensionsMillimeters: "157 x 52 x 37 mm",
        dimensionsInches: '(6.2 x 2.1 x 1.5")',
      },
    ],
    video: {
      src: protectViewportMp4,
      poster: protectViewportPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/ufp-viewport`,
    },
    previewImg: protectViewportPreviewPng,
  },
  {
    id: "EnterpriseHDD",
    title: "installationAddons.enterpriseHdd.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" },
      { id: BuildFeatureItemId.NvrPro, label: "UNVR Pro" },
      { id: BuildFeatureItemId.Nvr, label: "UNVR" },
    ],
    description: "installationAddons.enterpriseHdd.description",
    dimensions: [
      {
        dimensionsMillimeters: "147 x 101.9 x 26.1 mm",
        dimensionsInches: '(5.75 x 4 x 1")',
      },
    ],
    video: {
      src: enterpriseHddMp4,
      poster: enterpriseHddJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories`,
      searchParams: {
        subcategory: "accessories-storage",
      },
    },
    previewImg: hddStoragePreviewPng,
  },
  {
    id: "ToollessMiniRack",
    title: "installationAddons.toollessMiniRack.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" },
      { id: BuildFeatureItemId.NvrPro, label: "UNVR Pro" },
      { id: BuildFeatureItemId.Nvr, label: "UNVR" },
    ],
    dimensions: [
      {
        label:
          "installationAddons.toollessMiniRack.handleAndCaster.dimensions.label",
        dimensionsMillimeters: "519 x 460 x 485 mm",
        dimensionsInches: '(20.43 x 18.11 x 19.09")',
      },
      {
        label: "installationAddons.toollessMiniRack.withOut.dimensions.label",
        dimensionsMillimeters: "519 x 460 x 351 mm",
        dimensionsInches: '(20.43 x 18.11 x 13.82")',
      },
    ],
    description: "installationAddons.toollessMiniRack.description",
    video: {
      src: toollessMiniRackMp4,
      poster: toollessMiniRackJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/toolless-mini-rack`,
    },
    previewImg: toollessMiniRackPreviewPng,
  },
  {
    id: "LTEBackupPro",
    title: "installationAddons.lteBackupPro.title",
    description: "installationAddons.lteBackupPro.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" },
      { id: BuildFeatureItemId.NvrPro, label: "UNVR Pro" },
      { id: BuildFeatureItemId.Nvr, label: "UNVR" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "66 x 202 x 32 mm",
        dimensionsInches: '(2.6 x 8 x 1.3")',
      },
    ],
    video: {
      src: lteBackupProMp4,
      poster: lteBackupProJpg,
    },
    learnMoreLink: {
      path: `/unifi/integrations/u-lte-backup-pro`,
    },
    previewImg: lteBackupProPreviewPng,
  },
  {
    id: "PowerBackup",
    title: "installationAddons.powerBackup.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" },
      { id: BuildFeatureItemId.NvrPro, label: "UNVR Pro" },
      { id: BuildFeatureItemId.Nvr, label: "UNVR" },
    ],
    description: "installationAddons.powerBackup.description",
    dimensions: [
      {
        dimensionsMillimeters: "442.4 x 325.6 x 43.7 mm",
        dimensionsInches: '(17.4 x 12.8 x 1.7")',
      },
    ],
    video: {
      src: powerBackupMp4,
      poster: powerBackupPreviewJpg,
    },
    learnMoreLink: {
      path: `/unifi/integrations/usp-rps`,
    },
    previewImg: powerBackupPreviewPng,
  },
  {
    id: "PowerDistributionPro",
    title: "installationAddons.powerDistributionPro.title",
    description: "installationAddons.powerDistributionPro.description",
    dimensions: [
      {
        dimensionsMillimeters: "442.4 x 87.4 x 106 mm",
        dimensionsInches: '(17.4 x 3.4 x 4.2")',
      },
    ],
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" },
      { id: BuildFeatureItemId.NvrPro, label: "UNVR Pro" },
      { id: BuildFeatureItemId.Nvr, label: "UNVR" },
    ],
    video: {
      src: powerDistributionProMp4,
      poster: powerDistributionProJpg,
    },
    learnMoreLink: {
      path: `/unifi/integrations/usp-pdu-pro`,
    },
    previewImg: powerDistributionProPreviewPng,
  },
  {
    id: "RackMountOCDPanels",
    title: "installationAddons.rackMountOcdPanels.title",
    description: "installationAddons.rackMountOcdPanels.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" },
      { id: BuildFeatureItemId.NvrPro, label: "UNVR Pro" },
      { id: BuildFeatureItemId.Nvr, label: "UNVR" },
    ],
    video: {
      src: rackMountOcdPanelsMp4,
      poster: rackMountOcdPanelsJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-rack-panel-ocd`,
    },
    previewImg: rackMountOcdPanelsPreviewPng,
  },
  {
    id: "24PortBlankKeystonePatchPanel",
    title: "installationAddons.blankKeystonePatchPanel.title",
    description: "installationAddons.blankKeystonePatchPanel.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" },
      { id: BuildFeatureItemId.NvrPro, label: "UNVR Pro" },
      { id: BuildFeatureItemId.Nvr, label: "UNVR" },
    ],
    dimensions: [
      {
        label:
          "installationAddons.blankKeystonePatchPanel.standAlone.dimension.label",
        dimensionsMillimeters: "442.4 x 63.5 x 43.7 mm",
        dimensionsInches: '(17.4 x 2.5 x 1.7")',
      },
      {
        label:
          "installationAddons.blankKeystonePatchPanel.management.dimension.label",
        dimensionsMillimeters: "433.8 x 71.5 x 17 mm",
        dimensionsInches: '(17.1 x 2.8 x 0.7")',
      },
    ],
    video: {
      src: blankKeystonePatchPanelMp4,
      poster: blankKeystonePatchPanelPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-rack-panel-patch-blank-24`,
    },
    previewImg: blankKeystonePatchPanelPreviewPng,
  },
  {
    id: "PowerDistributionHiDensity",
    title: "installationAddons.powerDistributionHiDensity.title",
    description: "installationAddons.powerDistributionHiDensity.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Envr, label: "UNVR Enterprise" },
      { id: BuildFeatureItemId.NvrPro, label: "UNVR Pro" },
      { id: BuildFeatureItemId.Nvr, label: "UNVR" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "1485 x 55 x 56 mm",
        dimensionsInches: '(58.5 x 2.17 x 2.2")',
      },
    ],
    video: {
      src: powerDistributionHiDensityMp4,
      poster: powerDistributionHiDensityJpg,
    },
    learnMoreLink: {
      path: `/unifi/integrations/usp-pdu-hd`,
    },
    previewImg: powerDistributionHiDensityPreviewPng,
  },
  {
    id: "CloudkeyPlusStand",
    title: "installationAddons.cloudkeyPlusStand.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.CloudKeyPlus, label: "CloudKey+" }],
    dimensions: [
      {
        dimensionsMillimeters: "134.2 x 71.7 x 43.2 mm",
        dimensionsInches: '(5.3 x 2.8 x 1.7")',
      },
    ],
    description: "installationAddons.cloudkeyPlusStand.description",
    video: {
      src: cloudkeyPlusStandMp4,
      poster: cloudkeyPlusStandPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/cameras-nvrs/uacc-ckg2-plus-stand`,
    },
    previewImg: cloudkeyPlusStandPreviewPng,
  },
] satisfies TVideoCardFeatureV2[];
